import BroadcastsAPI from 'dashboard/api/broadcasts';
import { createStore } from './storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'Broadcast',
  API: BroadcastsAPI,
  actions: mutations => ({
    sendNow: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await BroadcastsAPI.sendNow(id);
        commit(mutations.EDIT, response.data);
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
